// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/new-components/templates/text-image/style.css
// module id = 1024
// module chunks = 0